import ModalMaster from "@/components/Modal/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
import Util from "@/helper/Utility.js";

export default {
    data: function () {
        return {
            modalFactory: new ModalFactory(),
            modalController: null,
            alertModal: null,
            confirmModal: null,
            loadingModal: null,
            successModal: null,
            //Authen
            otpModal: null,
            //redeem
            confirmRedeemModal: null,
            drawDeliveryModal: null,
            donateSuccessModal: null,
            serialModal: null,
            shippingAddressModal: null,
            freeDeliverySuccessModal: null,
            confirmDeliveryAddressModal: null,
            //custom modal,
            productDescriptionModal: null,
            pointSummaryModal: null,
            skipModal: null,
            pointCollectionStepModal: null,
            welcomePointModal: null,
            pointCollectionModal: null,
            alertRegisterModal: null,
            termModal: null,
            missionSuccessModal: null,
            unSubscribeModal: null,
            marketingModal: null,
            privacySettingModal: null,
            copyPersonalModal: null,
            termsRegisterModal: null,
            privacyRegisterModal: null,
            ageConsentAlertModal: null,
            reConsentMarketingModal: null,
            termsReConsentModal: null,
            privacyReConsentModal: null,
            marketingReConsentModal: null,
            leaderBoardConditionModal: null,
            welcomeCouponModal: null,
        };
    },
    components: {
        ModalMaster
    },
    created: function () {
        this.initialGenericModal();
        this.initialPointModal();

        if (Util.isFunction(this.setupModalCompleted)) {
            this.setupModalCompleted();
        }
    },
    methods: {
        initialGenericModal: function () {
            this.modalController = this.modalFactory.getModalController();
            this.alertModal = this.modalFactory.getAlertModal();
            this.confirmModal = this.modalFactory.getConfirmModal();
            this.loadingModal = this.modalFactory.getLoadingModal();
            this.otpModal = this.modalFactory.getOtpModalController();
            this.skipModal = this.modalFactory.getSkipModal();
            this.successModal = this.modalFactory.getSuccessModal();
            this.alertRegisterModal = this.modalFactory.getAlertRegisterModal();
            this.marketingModal = this.modalFactory.getMarketingModal();
            this.copyPersonalModal = this.modalFactory.getCopyPersonalModal();
            this.welcomeCouponModal = this.modalFactory.getWelcomeCouponModal();
        },
        initialRedeemModal: function () {
            this.confirmRedeemModal = this.modalFactory.getConfirmRedeemModal();
            this.drawDeliveryModal = this.modalFactory.getDrawDeliveryModal();
            this.donateSuccessModal = this.modalFactory.getDonateSuccessModal();
            this.serialModal = this.modalFactory.getSerialModal();
            this.shippingAddressModal = this.modalFactory.getShippingAddressModal();
            this.freeDeliverySuccessModal = this.modalFactory.getFreeDeliverySuccessModal();
            this.confirmDeliveryAddressModal = this.modalFactory.getConfirmDeliveryAddressModal();
        },
        initialHistoryModal: function () {
            this.serialModal = this.modalFactory.getSerialModal();
        },
        initialPointModal: function(){
            this.productDescriptionModal = this.modalFactory.getProductDescriptionModal();
            this.pointSummaryModal = this.modalFactory.getPointSummaryModal();
            this.pointCollectionModal = this.modalFactory.getPointCollectionModal();
        },
        initialProductDescriptionModal: function () {
            this.productDescriptionModal = this.modalFactory.getProductDescriptionModal();
        },
        initialPointSummaryModal: function () {
            this.pointSummaryModal = this.modalFactory.getPointSummaryModal();
        },
        initialPointCollectionStepModal: function () {
            this.pointCollectionStepModal = this.modalFactory.getPointCollectionStepModal();
        },
        initialOtherModal: function(){
            this.welcomePointModal = this.modalFactory.getWelcomePointModal();
            this.termModal = this.modalFactory.getTermModal();
            this.missionSuccessModal = this.modalFactory.getMissionSuccessModal();
            this.missionSuccessCheckinModal = this.modalFactory.getMissionSuccessCheckinModal(); 
            this.cancelMemberModal = this.modalFactory.getCancelMemberModal();
            this.privacySettingModal = this.modalFactory.getPrivacySettingModal();
            this.termsRegisterModal = this.modalFactory.getTermsRegisterModal();
            this.privacyRegisterModal = this.modalFactory.getPrivacyRegisterModal();
            this.ageConsentAlertModal = this.modalFactory.getAgeConsentAlertModal();
            this.marketingReConsentModal = this.modalFactory.getMarketingReConsentModal();
            this.termsReConsentModal = this.modalFactory.getTermsReConsentModal();
            this.privacyReConsentModal = this.modalFactory.getPrivacyReConsentModal();
            this.leaderBoardConditionModal = this.modalFactory.getLeaderBoardConditionModal();
            
        }
    }
}
